(()=> {
  if(!document.documentElement.classList.contains('danz-shell-page'))return;
  let components=false, commerce=false, revealed=false;
  const reveal=()=>{
    if(revealed||!components||!commerce)return;
    revealed=true;
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
      document.documentElement.classList.add('danz-shell-ready');
      document.dispatchEvent(new CustomEvent('danz:shell-ready'));
    }));
  };
  document.addEventListener('danz:components-mounted',()=>{components=true;reveal()},{once:true});
  document.addEventListener('danz:commerce-mounted',()=>{commerce=true;reveal()},{once:true});
  /* Fail-safe prevents a blank desktop if an unrelated optional initializer fails. */
  addEventListener('load',()=>setTimeout(()=>{
    if(!revealed)document.documentElement.classList.add('danz-shell-ready');
  },1200),{once:true});
})();